import http from '../plugins/axios'

export const getAllHscodes = async (params) => {
    try {
        const response = await http.get('/api/v2/hscode', { params })
        return response.data
    } catch (error) {
        throw error
    }
}

export const getDetailHscode = async (id, params) => {
    try {
        const response = await http.get(`/api/v2/hscode/${id}`, { params })
        return response.data
    } catch (error) {
        throw error
    }
}

export const createHscode = async (payload) => {
    try {
        const response = await http.post('/api/v2/hscode', payload)
        return response.data
    } catch (error) {
        throw error
    }
}

export const updateHscode = async (id, payload) => {
    try {
        const response = await http.put(`/api/v2/hscode/${id}`, payload)
        return response.data
    } catch (error) {
        throw error
    }
}

export const deleteHscode = async (id) => {
    try {
        const response = await http.delete(`/api/v2/hscode/${id}`)
        return response.data
    } catch (error) {
        throw error
    }
}
